import { useQuery } from "@tanstack/react-query"
import { getSellerProfileById } from "@/lib/api/seller.api"
import { useAuthStore } from "@/store/auth.store"

export function useSellerProfile() {
  const sellerProfileId = useAuthStore(
    (s) => s.sellerProfileId ?? s.user?.employeeProfile?.id ?? null
  )
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["seller-profile", sellerProfileId],
    queryFn: () => getSellerProfileById(sellerProfileId!, accessToken!),
    enabled: !!sellerProfileId && !!accessToken,
    staleTime: 0,
  })
}
